import { LEGACY_FLOW_TAGS, canonicalFlowTagId, type FlowTag } from "./flow-tags-domain";

/** User marks belong to model codes in the existing flow_marks store.
 * This column projects that data; it never loads an additional Ozon source. */
export const FLOW_MARKS_COLUMN_KEY = "flow_marks";
export const FLOW_MARKS_COLUMN_LABEL = "Метки";
export const FLOW_SUPER_MARK = { t: "супер", c: "#95651A", bg: "#FBF0DC" };

export function visibleFlowLabels(labels: readonly string[], tags: readonly FlowTag[] = LEGACY_FLOW_TAGS): string[] {
  const known = new Set(tags.map(tag => tag.id));
  return [...new Set(labels.map(canonicalFlowTagId))].filter(key => known.has(key));
}

/** Complete text, not the compact visual summary, is used by export/sort. */
export function flowMarksText(labels: readonly string[], isSuper = false, tags: readonly FlowTag[] = LEGACY_FLOW_TAGS): string {
  const names = new Map(tags.map(tag => [tag.id, tag.name]));
  return [...visibleFlowLabels(labels, tags).map(key => names.get(key)!), ...(isSuper ? ["Супер (Ozon)"] : [])].join(", ");
}

export function changeFlowBookmarks(watch: string[], codes: readonly string[], enabled: boolean): string[] {
  const selected = new Set(codes.filter(Boolean));
  const current = new Set(watch);
  if (enabled) {
    const missing = [...selected].filter(code => !current.has(code));
    return missing.length ? [...watch, ...missing] : watch;
  }
  return watch.some(code => selected.has(code)) ? watch.filter(code => !selected.has(code)) : watch;
}

/** Update the entire selection once. Remove empty records, keep unrelated
 * marks and return the same object when the requested state already exists. */
export function changeFlowLabels(labels: Record<string, string[]>, codes: readonly string[], key: string, enabled: boolean, tags: readonly FlowTag[] = LEGACY_FLOW_TAGS): Record<string, string[]> {
  key = canonicalFlowTagId(key);
  if (!tags.some(tag => tag.id === key)) return labels;
  let next = labels;
  for (const code of new Set(codes)) {
    if (!code) continue;
    const current = Object.hasOwn(labels, code) ? labels[code].map(canonicalFlowTagId) : [];
    if (current.includes(key) === enabled) continue;
    if (next === labels) next = { ...labels };
    const changed = enabled ? [...current, key] : current.filter(value => value !== key);
    if (changed.length) Object.defineProperty(next, code, { value: changed, enumerable: true, configurable: true, writable: true }); else delete next[code];
  }
  return next;
}
